<template>
  <div class="flex items-stretch h-full">
    <div class="hidden md:flex w-2/4 bg-primary dark:bg-primary-900 text-xs relative">
      <img class="object-cover mix-blend-soft-light filter grayscale" src="@/assets/img/grupo-login.png" alt="aside" />
      <div class="absolute bottom-4 left-0 w-full z-10 text-white hidden">
        <div class="p-8">
          <h2 class="text-4xl font-bold mb-2">One Ring to rule them all</h2>
          <h3 class="text-xl font-medium opacity-80">One Ring to find them, One Ring to bring them all, and in the darkness bind them</h3>
        </div>
        <p class="text-center border-t border-solid border-white border-opacity-20 pt-4">
          Photo by <a href="#" class="">Jesper Aggergaard</a> on
          <a href="#" class="">Unsplash</a>
        </p>
      </div>
    </div>
    <div class="w-full flex flex-col min-h-full">
      <div class="main flex-grow">
        <div class="w-full flex flex-col min-h-full dark:bg-darkblue-900">
          <div class="flex flex-grow items-center justify-center">
            <div class="w-full max-w-sm relative">
              <base-logo alt="Real Grupo Cultural Covadonga, control de accesos" class="mx-auto mb-6 brand" />
              <div class="text-center">
                <h2 class="font-bold leading-tight">Área restringida</h2>
                <p class="text-sm leading-tight mt-1">Lo sentimos mucho, pero el acceso se encuentra restringido para uso exclusivo de socios.</p>
              </div>
              <form class="px-4 mt-4 sm:px-0">
                <base-button class="w-full" mode="primary" text="Cerrar sesión" :loading="logging" :disabled="logging" @click="logout" />
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NoMember',
  data: function () {
    return {
      logging: false
    }
  },
  methods: {
    logout: function (path) {
      this.$store.dispatch('auth/logout')
    }
  }
}
</script>
